var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnderline = function SvgUnderline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    fill: "currentColor",
    viewBox: "0 0 12 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.623 7.91895H4.377L3.577 9.91895H2.5L5.5 2.41895H6.5L9.5 9.91895H8.423L7.623 7.91895ZM7.223 6.91895L6 3.86145L4.777 6.91895H7.223ZM1.5 10.9189H10.5V11.9189H1.5V10.9189Z"
  })));
};
export default SvgUnderline;